<template>
  <!-- 
  侧边 位置尺寸
 -->
  <div class="ChartsPosSizeConfiger">
    <div class="p-name">位置尺寸</div>
    <div class="p-pos">
      <span>X轴</span>
      <el-input size="mini" @blur="handleChange" v-model="posSize.left" placeholder=""></el-input>
      <span>Y轴</span>
      <el-input size="mini" @blur="handleChange" v-model="posSize.top" placeholder=""></el-input>
    </div>
    <div class="p-manual-select-pos">
      <span>定位</span>
      <el-select v-model="selectedPos" @change="handlePosChange" size="mini" placeholder="请选择">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="p-size">
      <span>宽</span>
      <el-input size="mini" @blur="handleChange" v-model="posSize.width" placeholder=""></el-input>
      <span>高</span>
      <el-input size="mini" @blur="handleChange" v-model="posSize.height" placeholder=""></el-input>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'ChartsPosSizeConfiger',
  /*  prop属性只读 不可直接修改 会影响性能以及维护性 */
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      posSize: {
        width: 0,
        height: 0,
        left: 0,
        top: 0,
      },
      options: [
        {
          label: '顶部居中',
          value: 'center-top',
        },
        {
          label: '居中定位',
          value: 'center-center',
        },
        {
          label: '底部居中',
          value: 'center-bottom',
        },
        {
          label: '居中-左',
          value: 'center-left',
        },
        {
          label: '居中-右',
          value: 'center-right',
        },
        {
          label: '右-上',
          value: 'right-top',
        },

        {
          label: '右-下',
          value: 'right-bottom',
        },

        {
          label: '左-上',
          value: 'left-top',
        },
        {
          label: '左-下',
          value: 'left-bottom',
        },
      ],
      selectedPos: '',
      timerId: null,
      isEding: false,
    };
  },
  watch: {
    asyncCurrentConfigration: {
      deep: true,
      handler: function () {
        this.debounce_updateCurrentShowPosSize();
      },
    },
  },
  computed: {
    ...mapState({
      ProjectInfo: state => state.ProjectInfo,
    }),
    asyncCurrentConfigration() {
      return this.$store.state.CurrentConfigration;
    },
  },

  created() {
    this.initCurrentPropertyData();
    this.debounce_updateCurrentShowPosSize = this.$_.debounce(this.updateCurrentShowPosSize, 300);
  },
  mounted() {},
  unmounted() {
    this.debounce_updateCurrentShowPosSize.cancel();
  },
  methods: {
    handlePosChange(val) {
      console.log(val, '拖动组件');
      this.updateCurrentShowPosSize();
      console.log(this.ProjectInfo, '图表背景数据');
      let { ScreenSize, ScreenRatio } = this.ProjectInfo;
      // vuex 提交 设置是否正在更改组件位置 拖动组件
      this.$store.commit('set_isEdingChartsPosSize', true);
      let currentScreenSizeWidth = Math.round((ScreenSize.width * ScreenRatio.w_Ratio) / 100);
      let currentScreenSizeHeight = Math.round((ScreenSize.height * ScreenRatio.h_Ratio) / 100);
      switch (val) {
        case 'center-center':
          this.posSize.left = currentScreenSizeWidth / 2 - this.posSize.width / 2;
          this.posSize.top = currentScreenSizeHeight / 2 - this.posSize.height / 2;
          break;
        case 'center-bottom':
          this.posSize.left = currentScreenSizeWidth / 2 - this.posSize.width / 2;
          this.posSize.top = currentScreenSizeHeight - this.posSize.height;
          break;
        case 'center-top':
          this.posSize.left = currentScreenSizeWidth / 2 - this.posSize.width / 2;
          this.posSize.top = 0;
          break;
        case 'center-left':
          this.posSize.left = 0;
          this.posSize.top = currentScreenSizeHeight / 2 - this.posSize.height / 2;
          break;
        case 'center-right':
          this.posSize.left = currentScreenSizeWidth - this.posSize.width;
          this.posSize.top = currentScreenSizeHeight / 2 - this.posSize.height / 2;
          break;
        case 'right-top':
          this.posSize.left = currentScreenSizeWidth - this.posSize.width;
          this.posSize.top = 0;
          break;
        case 'right-bottom':
          this.posSize.left = currentScreenSizeWidth - this.posSize.width;
          this.posSize.top = currentScreenSizeHeight - this.posSize.height;
          break;
        case 'left-top':
          this.posSize.left = 0;
          this.posSize.top = 0;
          break;
        case 'left-bottom':
          this.posSize.left = 0;
          this.posSize.top = currentScreenSizeHeight - this.posSize.height;
          break;
        default:
          break;
      }
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: { ...this.posSize },
      });
      setTimeout(() => {
        this.isEding = false;
        this.$store.commit('set_isEdingChartsPosSize', false);
      }, 600);
    },
    updateCurrentShowPosSize() {
      let currentStyle = this.asyncCurrentConfigration.style;
      if (currentStyle && !this.isEding) {
        this.posSize = { ...currentStyle };
      }
    },
    initCurrentPropertyData() {
      this.posSize = { ...this.asyncCurrentConfigration.style };
    },
    commitCurrentPropertyData(val) {
      console.log(val, 'commitCurrentPropertyData');
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: val,
      });
    },
    handleChange() {
      this.$store.commit('set_isEdingChartsPosSize', true);
      this.isEding = true;
      for (let key in this.posSize) {
        this.posSize[key] = parseInt(this.posSize[key]);
      }
      console.log(this.posSize, 'commitCurrentPropertyData');
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: { ...this.posSize },
      });
      setTimeout(() => {
        this.isEding = false;
        this.$store.commit('set_isEdingChartsPosSize', false);
      }, 600);
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.ChartsPosSizeConfiger {
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;

  .p-name {
    color: $property-title-color;
    font-size: $property-title-size;
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    height: 30px;
    line-height: 30px;
  }
  .p-pos {
    margin: 5px 0;
    color: $property-attributes-color;
    font-size: $property-attributes-size;
    width: 100%;
    height: 30px;
    box-sizing: border-box;
    display: flex;
    padding: 0 15px;
    align-items: center;
    justify-content: space-between;

    span {
      width: 50px;
      box-sizing: border-box;
      padding-left: 5px;
    }

    .el-input {
      width: 65px;
    }

    :deep() input {
      color: #ffffff;
      background: #191b23;
      border-radius: 0;
      border-collapse: collapse;
      text-align: center;
      border: 1px solid rgb(90, 90, 90);

      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
  .p-size {
    margin: 5px 0;
    color: $property-attributes-color;
    font-size: $property-attributes-size;
    width: 100%;
    height: 30px;
    box-sizing: border-box;
    display: flex;
    padding: 0 15px;
    align-items: center;
    justify-content: space-between;

    span {
      width: 50px;
      box-sizing: border-box;
      padding-left: 5px;
    }

    .el-input {
      width: 65px;
    }

    :deep() input {
      color: #ffffff;
      background: #191b23;
      border-radius: 0;
      border-collapse: collapse;
      text-align: center;
      border: 1px solid rgb(90, 90, 90);

      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
  .p-manual-select-pos {
    margin: 5px 0;
    color: $property-attributes-color;
    font-size: $property-attributes-size;
    width: 100%;
    height: 30px;
    box-sizing: border-box;
    display: flex;
    padding: 0 15px;
    align-items: center;
    justify-content: space-between;
    span {
      width: 50px;
      box-sizing: border-box;
      padding-left: 5px;
    }
    .el-select {
      width: 192px;

      :deep() input {
        color: #ffffff;
        background: #191b23;
        border-radius: 0;
        border-collapse: collapse;
        text-align: center;
        border: 1px solid rgb(90, 90, 90);

        &:hover {
          border: 1px solid #3179ff;
        }
        &:focus {
          border: 1px solid #3179ff;
        }
      }
    }
  }
}
</style>
